import {createSelector} from '@reduxjs/toolkit';

import {TAppState} from '../../config/types';
import {NET_DIRECTORY_FILE_SLICE} from './net-directory-file-slice-constants';

const selectNetDirectoryFileSliceState = (state: TAppState) => state[NET_DIRECTORY_FILE_SLICE];

export const selectNetDirectoryFileName = createSelector(
    selectNetDirectoryFileSliceState,
    state => state?.fileNameList,
);

export const selectNetDirectoryFileData = createSelector(
    selectNetDirectoryFileSliceState,
    state => state?.netDirectoryFileData,
);
